import {
  ListProps,
  TextField,
  DateField,
} from 'react-admin';

import { TextInput, Grid, GridList, Forbidden, JsonField } from '@components';
import { useRbacList } from '@hooks';

export const SalesforceLogList = (props: ListProps) => {
  const rbacList = useRbacList();

  if (!rbacList) {
    return <Forbidden />;
  }

  return (
    <GridList {...props}
      filters={Filters}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <Grid
        rowClick={false}
        defaultColumns={['userName', 'creditCode', 'callTitle', 'leadName', 'dealerName',
          'requestAt', 'requestJson', 'responseJson', 'errorJson']}
      >
        <TextField source="id" label="ID" />
        <TextField source="userName" label="User" />
        <TextField source="creditCode" label="Credit" />
        <TextField source="callTitle" label="Call" />
        <TextField source="leadName" label="Lead" />
        <TextField source="dealerName" label="Partner" />
        <DateField source="requestAt" label="Sync At" showTime />
        <JsonField source="requestJson" label="Request" />
        <JsonField source="responseJson" label="Response" />
        <JsonField source="errorJson" label="Error" />
      </Grid>
    </GridList>
  );
};

const Filters = [
  <TextInput source="q" key="q" label="Search" alwaysOn style={{ width: 220 }} />,
];
